
import { InputControlMask } from './InputControlMask';
import { Tooltip } from './Tooltip';

const Input = ({
    id,
    field,
    label,
    type = 'text',
    placeholder = '',
    value,
    isRequired = true,
    isReadOnly,
    onChange,
    mask,
    pattern,
    title,
    onlyInput = false,
    cssClassStyle = '',
    useToolTip = false,
    textToolTip = '',
    titleToolTip = ''
}: IPropsInput) => {

    const cssInput = `input-field-autoni ${cssClassStyle}`;
    const cssInputTable = `input-field-table-ihcr ${cssClassStyle}`;

    const GetType = (typeInput: string) => {
        switch (typeInput) {
            case 'text':
                return <input
                    id={id}
                    name={field}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    onChange={onChange}
                    readOnly={isReadOnly}
                    className={cssInput}
                    autoComplete='off'
                />;
            case 'textTable':
                return <input
                    id={id}
                    name={field}
                    type='number'
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    onChange={onChange}
                    readOnly={isReadOnly}
                    className={cssInputTable}
                    autoComplete='off'
                />;
            case 'textarea':
                return <textarea
                    name={field}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    onChange={onChange}
                    readOnly={isReadOnly}
                    className={`${cssInput} input-field-area-ihcr`}
                    autoComplete='off'
                    wrap='hard'
                />

            case 'email':
                return <input
                    id={id}
                    name={field}
                    onChange={onChange}
                    //className={cssClassInput}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    className={cssInput}

                />;
                return;
            case 'number':
                return <input
                    id={id}
                    name={field}
                    onChange={onChange}
                    className={cssInput}
                    type={type}
                    placeholder={placeholder}
                    value={value}
                    required={isRequired}
                    min={0}
                    autoComplete='off'
                    readOnly =   {isReadOnly}
                />

            case 'mask':
                return <InputControlMask
                    name={field}
                    onChange={onChange}
                    className={cssInput}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    mask={mask}
                    required={isRequired}
                    pattern={pattern}
                    title={title}
                    autoComplete='off'
                />;
        }

    }

    const cssLabel = useToolTip ? 'display-flex' : '';


    return (
        <>
            {!onlyInput && <div className={`lbl-input-autoni mt-20 mb-5 ${cssLabel}`}>
                <span> {label} </span>
                { useToolTip && <Tooltip id={`${field}T`} key={`${field}T`} text={textToolTip} title={titleToolTip} /> }
            </div>}
            <div className="mb-10">
                {GetType(type)}
            </div>
        </>
    );
};

export { Input };